<template>
  <div
    id="app"
    :data-theme="darkMode ? 'dark' : ''">
    <el-container>
      <el-dialog
        :visible.sync="isUnsupportedBrowser"
        :show-close="false"
        title="Unsupported Browser"
        width="30%"
        center>
        <b>We have detected an unsupported browser.</b>
        <p>
          Please upgrade your browser to improve your experience. We recommend using Google Chrome.
        </p>
        <span slot="footer">
          <el-button
            @click="openNewWindow('https://www.browsehappy.com/')">
            Explore Options
          </el-button>
          <el-button
            type="primary"
            @click="openNewWindow('https://www.google.com/chrome')">
            Download Chrome
          </el-button>
        </span>
      </el-dialog>
      <component
        :is="layout">
        <transition
          mode="out-in"
          name="fade-down">
          <router-view
            v-loading="routerLoading"
            :key="routeKey"/>
        </transition>
      </component>
      <vue-progress-bar/>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BasicLayout from '@/components/layout/BasicLayout'
import EmptyLayout from '@/components/layout/EmptyLayout'
import SidebarLayout from '@/components/layout/SidebarLayout'

export default {
  name: 'App',
  components: {
    BasicLayout,
    EmptyLayout,
    SidebarLayout,
  },
  data() {
    return {
      isUnsupportedBrowser: false,
      routerLoading: false,
    }
  },
  computed: {
    ...mapGetters('Auth', [
      'user',
    ]),
    layout() {
      return `${(this.$route.meta.layout || 'Empty')}Layout`
    },
    darkMode() {
      return this.$store.state.DarkMode.enabled
    },
    routeKey() {
      if (this.$route.params && this.$route.params.id) {
        return `${this.user.id}:${this.$route.params.id}`
      }
      return this.user.id
    },
  },
  mounted() {
    const ua = window.navigator.userAgent
    // Detect Internet Explorer
    // IE < 11 contains string 'MSIE'
    // IE >= 8 contains string 'Trident'
    if (ua.indexOf('MSIE ') > -1) {
      /* eslint-disable-next-line no-console */
      console.log('You\'re using an unsupported browser.')
      this.isUnsupportedBrowser = true
    }
  },
  created() {
    //  hook the progress bar to start before we move router-view
    this.$router.beforeResolve((to, from, next) => {
      next()
    })
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(() => {
    })
  },
  methods: {
    openNewWindow(url) {
      window.open(url)
    },
  },
}
</script>

<style lang="scss">
@import '../assets/styles/main';
</style>

<style lang="scss" scoped>
@import '../assets/styles/main';
.fade-down-enter-active {
    animation-name: fadeInDown;
    animation-duration: 0.2s;
}

.fade-down-leave-active {
    animation-name: fadeOutDown;
    animation-duration: 0.2s;
}

@keyframes fadeInDown {
  from { opacity: 0.05; transform: translate3d(0, -15px, 0); }
  to { opacity: 1; transform: none; }
}

@keyframes fadeOutDown {
  from {  opacity: 1; transform: none; }
  to { opacity: 0.05; transform: translate3d(0, -15px, 0); }
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue